import { useState, useEffect } from "react";
import "@/App.css";
import { motion, AnimatePresence } from "framer-motion";
import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";
import Services from "./components/Services";
import Gallery from "./components/Gallery";
import Testimonials from "./components/Testimonials";
import ServiceAreas from "./components/ServiceAreas";
import Contact from "./components/Contact";
import Blog from "./components/Blog";
import Footer from "./components/Footer";
import QuoteModal from "./components/QuoteModal";

function App() {
  const [isLoading, setIsLoading] = useState(true);
  const [isQuoteOpen, setIsQuoteOpen] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsLoading(false), 500);
    return () => clearTimeout(timer);
  }, []);

  const openQuote = () => setIsQuoteOpen(true);
  const closeQuote = () => setIsQuoteOpen(false);

  return (
    <div className="App bg-primary-bg min-h-screen">
      <AnimatePresence>
        {isLoading ? (
          <motion.div
            key="loader"
            initial={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
            className="fixed inset-0 bg-primary-bg z-50 flex items-center justify-center"
          >
            <motion.div
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.3 }}
              className="text-accent text-2xl font-heading"
            >
              Rimsie Constructions Pty Ltd
            </motion.div>
          </motion.div>
        ) : null}
      </AnimatePresence>

      <Header onQuoteClick={openQuote} />
      <main>
        <Hero onQuoteClick={openQuote} />
        <About />
        <Gallery />
        <Services />
        <Testimonials />
        <ServiceAreas />
        <Blog />
        <Contact onQuoteClick={openQuote} />
      </main>
      <Footer />

      <QuoteModal isOpen={isQuoteOpen} onClose={closeQuote} />
    </div>
  );
}

export default App;
